function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.33798 10.2599C5.89698 7.91586 6.44398 5.56886 7.02198 3.23085C7.40498 1.68586 8.03298 1.25886 9.55098 1.62086C12.689 2.37086 15.818 3.16385 18.941 3.97185C20.269 4.31385 20.719 5.06485 20.403 6.40985C19.26 11.2649 18.1 16.1139 16.924 20.9609C16.613 22.2419 15.885 22.7149 14.627 22.4119C11.371 21.6269 8.12098 20.8099 4.87598 19.9719C3.67198 19.6599 3.29098 18.9129 3.60598 17.5379C4.16198 15.1059 4.75798 12.6839 5.33798 10.2599Z",
  fill: "#FF381A"
});

var SvgRedCard = function SvgRedCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redCard.0420d9a5.svg";
export { ForwardRef as ReactComponent };